import script from "./boot-type-distribution-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./boot-type-distribution-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__